import { useQuery } from '@tanstack/react-query';

import { get } from '../../../../lib/api';

const useGetDeliver = () => {
  const {
    data = {
      digest_send_to_options: [],
      follow_up_day_options: [],
      population_segments_options: [],
      is_empty: true,
    },
  } = useQuery(['deliver'], () => get('/api/client_admin/send/deliver'));

  return data;
};

export default useGetDeliver;
